import {CollectCompany} from "@/entity/CollectCompany";
import {Base} from "@/dto/Base";

import {RemoveEmptyUtils} from "pansx-utils/src/index";
import {SecurityRequestBase} from "@/oauth/SecurityRequestBase";
import {Customer} from "@/entity/Customer";

export class CollectCompanyDto{
    public static  url ='/collectCompany';

    public  static  async  findById(userId: number): Promise<CollectCompany>{
        const response = await  Base.getDataWithJwt(this.url + '/byId',{userId});
        const  collectCompany = response as CollectCompany;
        return collectCompany;
    }

    public static async  findCustomerByUserId(userId: number): Promise<Customer>
    {
        const response = await  Base.getDataWithJwt(this.url + '/byId',{userId});
        const  customer = response as Customer;
        return customer;
    }

    public static async findAll(collectCompany: CollectCompany): Promise<CollectCompany[]> {
        RemoveEmptyUtils.removeEmptyString(collectCompany);
        RemoveEmptyUtils.removeZero(collectCompany);
        const response = await Base.getDataWithJwt<CollectCompany[]>(
            this.url + '/all',
            collectCompany
        );
        const collectCompanyList = response as CollectCompany[];
        return collectCompanyList;
    }


    public static async delete(id: number) {
        await Base.getData(this.url + '/delete', { id });
    }

    public static async save(collectCompany: CollectCompany): Promise<CollectCompany> {
        // if (collectCompany.userId != null){
        //     collectCompany.
        // }
        const response = await Base.postWithToken(this.url + '/save', collectCompany);
        return response as CollectCompany;
    }



}

